import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { enterAdminArea } from '../actions/actionsAdmin';
import { changeMenuActiveKey, changeSideMenu } from '../actions/actionsMenu';
import { changeActiveKey } from '../actions/actionsNavbar';
import { changeActiveKeyAdmin } from '../actions/actionsNavbarAdmin';
import { selectorUser } from '../lib/selectorUser';
import { SET_NAVBAR_STATE } from '../reducers/navBar/data';
import { syncLastNonAdminRoute } from '../utils/AdminNavigation';
import { IPA_PRICE_ARCHITECTURE_PATH } from '../utils/ipaAccess';
import { findNavBarPayloadByKey } from './NavBar/utils';

const RouteChange = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector(selectorUser);

  const menuChanged = useCallback(
    pathname => {
      if (pathname === '/isa/historico-preco') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname === '/isa/extracao-dados') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('3'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname === '/isa/download-relatorio') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname === '/isa/gestao-retorno') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('4'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname === '/isa/revisao-lista') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('6'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname === '/isa/lojas-bloqueadas') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('7'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname && pathname.includes('/acompanhamento')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('3'));
        dispatch(changeSideMenu('3'));
        dispatch(SET_NAVBAR_STATE({ panel: null, label: 'Painéis Customizados' }));
      }
      if (pathname === '/isa/acompanhamento-coletas') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('5'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname && pathname.includes('/isa/acompanhamento-coletas/detalhe')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('1'));
        dispatch(changeSideMenu('1'));
        dispatch(changeMenuActiveKey('5'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('COL', user)));
      }
      if (pathname && pathname.includes('/analise')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('3'));
        dispatch(changeSideMenu('3'));
        dispatch(SET_NAVBAR_STATE({ panel: null, label: 'Painéis Customizados' }));
      }
      if (pathname === '/isa/painel-geral' || pathname === '/isa/painel-geral-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/solicitacao-ondemand' || pathname === '/isa/solicitacao-ondemand-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/solicitacao-ondemand/sistema' || pathname === '/isa/solicitacao-ondemand-free/sistema') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/modulo-relatorio' || pathname === '/isa/modulo-relatorio-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('3'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/analise-competitividade/varejo' || pathname === '/isa/analise-competitividade/varejo-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('4'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/analise-competitividade/produtos' || pathname === '/isa/analise-competitividade/produtos-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('4'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/lojas-concorrentes' || pathname === '/isa/lojas-concorrentes-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('5'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/analise-cobertura' || pathname === '/isa/analise-cobertura-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('6'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/aderencia-precos' || pathname === '/isa/aderencia-precos-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('7'));
      }
      if (pathname === '/isa/elasticidade-cruzada') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('8'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/visao-geral-elasticidade') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('8'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname === '/isa/modulo-omnichannel' || pathname === '/isa/modulo-omnichannel-free') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('9'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname && pathname.startsWith('/isa/central-de-monitoramento')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('4'));
        dispatch(changeSideMenu('4'));
        dispatch(changeMenuActiveKey('10'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('PAN', user)));
      }
      if (pathname && pathname.includes('/ipa/precificacao-produto')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('2-1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname === '/ipa/historico-preco') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('6'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname === '/ipa/extracao-preco') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('5'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/regras-preco')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/limites-preco')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/regras-atacado')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-3'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/gerenciador-de-precos')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('4'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/campanhas')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('8'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/preco-psicologico')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-3'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/tabela-precos')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-4'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes(IPA_PRICE_ARCHITECTURE_PATH)) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-5b'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname === '/ipa/estrategia/margem-objetiva') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-5'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname === '/ipa/estrategia/preco-atacado') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('1-6'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname === '/ipa/ia/otimizacao-de-precos/lista') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('7-1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/ia/simulacoes-analises')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('7-2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/negociacoes/fornecedor')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('3-1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }
      if (pathname && pathname.includes('/ipa/negociacoes/salvas')) {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('5'));
        dispatch(changeSideMenu('6'));
        dispatch(changeMenuActiveKey('3-2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IPA', user)));
      }

      if (pathname && pathname.startsWith('/administrador')) {
        dispatch(enterAdminArea(true));
        dispatch(changeSideMenu(null));
      }
      if (pathname && pathname.includes('/administrador/pessoas')) {
        dispatch(changeActiveKeyAdmin('1'));
      }
      if (pathname && pathname.includes('/administrador/produtos')) {
        dispatch(changeActiveKeyAdmin('2'));
      }
      if (pathname && pathname.includes('/upload')) {
        dispatch(enterAdminArea(false));
      }

      if (pathname === '/ira') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('2'));
        dispatch(changeSideMenu('7'));
        dispatch(changeMenuActiveKey('1'));
        dispatch(SET_NAVBAR_STATE({ panel: null, label: 'Painéis Customizados' }));
      }
      if (pathname === '/ira/competitividade-geral') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('2'));
        dispatch(changeSideMenu('7'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE({ panel: null, label: 'Painéis Customizados' }));
      }
      if (pathname === '/ira/margem-praticada-geral') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('2'));
        dispatch(changeSideMenu('7'));
        dispatch(changeMenuActiveKey('3'));
        dispatch(SET_NAVBAR_STATE({ panel: null, label: 'Painéis Customizados' }));
      }
      if (pathname === '/ira/vendas-gerais') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('2'));
        dispatch(changeSideMenu('7'));
        dispatch(changeMenuActiveKey('4'));
        dispatch(SET_NAVBAR_STATE({ panel: null, label: 'Painéis Customizados' }));
      }
      if (pathname === '/ipa/calculadora-demanda') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('9'));
        dispatch(changeMenuActiveKey('1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('SDD', user)));
      }
      if (pathname === '/ipa/cenarios-salvos') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('9'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('SDD', user)));
      }
      if (pathname === '/ipa/comparacao-cenarios') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('9'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('SDD', user)));
      }
      if (pathname === '/ipa/plataforma-editar-tabela-base') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('10'));
        dispatch(changeMenuActiveKey('2'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IDT', user)));
      }
      if (pathname === '/ipa/criar-tabela-comercial') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('10'));
        dispatch(changeMenuActiveKey('3'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IDT', user)));
      }
      if (pathname === '/ipa/tabela-base-atual') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('10'));
        dispatch(changeMenuActiveKey('4'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IDT', user)));
      }
      if (pathname === '/ipa/lista-tabelas-preco') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('10'));
        dispatch(changeMenuActiveKey('3'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IDT', user)));
      }
      if (pathname === '/ipa/gerenciar-tabela-comercial') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('10'));
        dispatch(changeMenuActiveKey('1'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IDT', user)));
      }
      if (pathname === '/ipa/consultar-tabela-comercial') {
        dispatch(enterAdminArea(false));
        dispatch(changeActiveKey('7'));
        dispatch(changeSideMenu('10'));
        dispatch(changeMenuActiveKey('7'));
        dispatch(SET_NAVBAR_STATE(findNavBarPayloadByKey('IDT', user)));
      }
    },
    [dispatch, user],
  );

  useEffect(() => {
    const currentRoute = `${location.pathname}${location.search}${location.hash}`;

    syncLastNonAdminRoute(currentRoute);
  }, [location.hash, location.pathname, location.search]);

  useEffect(() => {
    menuChanged(location.pathname);
  }, [location.pathname, menuChanged]);

  return null;
};

export default RouteChange;
